import accountViewIcon from '../../assets/png/accountViewIcon.png';
import appstoreImg from '../../assets/png/appstore.png';
import downloadIcon from '../../assets/png/downloadIcon.png';
import playstoreImg from '../../assets/png/playstore.png';
import secureIcon from '../../assets/png/secureIcon.png';
import trackIcon from '../../assets/png/trackIcon.png';
import welcomeHero from '../../assets/png/welcomeImg.png';
import JDFLogo from '../../assets/svg/Logo.svg';
import YoutubeIcon from '../../assets/svg/youtube.svg';
import {ONBOARD_VIDEO_UNLEASH_KEY} from '../../utils/constant';
import Smartlook from '../../utils/smartlook';
import {sendScreenViewNR} from '../../utils/util';

import {Button} from '@deere/fuel-react';
import {useOktaAuth} from '@okta/okta-react';
import {
  useFlag,
  useUnleashClient,
  useVariant,
} from '@unleash/proxy-client-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import './WelcomePage.css';

const WelcomeFooter = ({className}) => {
  const {t} = useTranslation();
  return (
    <div className={className}>
      <div className="welcome-footer-links">
        <a
          href="https://www.deere.com/en/privacy-and-data/"
          target="_blank"
          rel="noreferrer"
        >
          {t('PRIVACY_AND_DATA')}
        </a>
        <span className="welcome-footer-divider">|</span>
        <a
          href="https://www.deere.com/en/privacy-and-data/terms/"
          target="_blank"
          rel="noreferrer"
        >
          {t('TERMS_OF_USE')}
        </a>
      </div>
      <p className="welcome-footer-legal">{t('APPLE_GOOGLE_LEGAL')}</p>
      <p className="welcome-footer-copyright">{t('COPYRIGHT')}</p>
    </div>
  );
};

const features = [
  {
    icon: <img src={secureIcon} alt="Secure Access" />,
    labelKey: 'SECURE_ACCESS',
  },
  {
    icon: <img src={trackIcon} alt="Track Requests" />,
    labelKey: 'TRACK_REQUESTS',
  },
  {
    icon: <img src={accountViewIcon} alt="Account Overview" />,
    labelKey: 'ACCOUNT_OVERVIEW_LABEL',
  },
  {
    icon: <img src={downloadIcon} alt="Get Documents" />,
    labelKey: 'GET_DOCUMENTS',
  },
];

const WelcomePage = () => {
  const {t, i18n} = useTranslation();
  const {oktaAuth} = useOktaAuth();
  const navigate = useNavigate();
  const client = useUnleashClient();

  const [selectedCountry] = React.useState(
    localStorage.getItem('countryCode')
      ? localStorage.getItem('countryCode')
      : 'en'
  );

  const showVideo = useFlag(ONBOARD_VIDEO_UNLEASH_KEY);
  const videoVariant = useVariant(ONBOARD_VIDEO_UNLEASH_KEY);
  const videoUrl = videoVariant?.payload?.value;

  // React.useEffect(() => {
  //   i18n.changeLanguage(selectedCountry);
  //   localStorage.setItem(`countryCode`, selectedCountry);
  //   client?.updateContext({country: selectedCountry});
  //   Smartlook.navigation('welcomePage');
  // }, [selectedCountry]);
  React.useEffect(() => {
    const countryCode = localStorage.getItem('countryCode');
    if (countryCode) {
      i18n.changeLanguage(countryCode);
      client.updateContext({country: countryCode});
    }
    sendScreenViewNR('welcomePage');
    Smartlook.navigation('welcomePage');
  }, []);

  const handleSignIn = () => {
    oktaAuth.setOriginalUri('/');
    oktaAuth.signInWithRedirect();
  };

  const handleCreateAccount = () => {
    navigate('/verification');
  };

  return (
    <div className="welcome-wrapper">
      {/* Left panel */}
      <div className="welcome-left">
        <div className="welcome-left-content">
          <img
            src={JDFLogo}
            alt={t('JOHN_DEERE_FINANCIAL')}
            className="welcome-logo"
          />
          <h1 className="welcome-title">{t('WELCOME_MYFINANCIAL')}</h1>
          <p className="welcome-subtitle">{t('WELCOME_SUBTITLE')}</p>
          <Button
            variant="primary"
            className="welcome-btn"
            onClick={handleCreateAccount}
            id="welcome-createAccount"
          >
            {t('CREATE_NEW_ACCOUNT')}
          </Button>
          <Button
            variant="secondary"
            className="welcome-btn"
            onClick={handleSignIn}
            id="welcome-signIn"
          >
            {t('SIGN_IN')}
          </Button>
          {showVideo && (
            <div className="welcome-guide-link">
              <span>{t('NEW_HERE')}</span>
              <img src={YoutubeIcon} alt="" className="welcome-youtube-icon" />
              <a
                href={videoUrl}
                target="_blank"
                rel="noreferrer"
                className="welcome-guide-anchor"
                id="welcome-onboardingVideo"
              >
                {t('WATCH_CREATE_ACCOUNT_GUIDE')}
              </a>
            </div>
          )}
        </div>
        <WelcomeFooter className="welcome-footer welcome-footer--desktop" />
      </div>

      {/* Right panel / hero image */}
      <div className="welcome-right">
        <div
          className="welcome-right-inner"
          style={{backgroundImage: `url(${welcomeHero})`}}
        >
          <div className="welcome-hero-overlay">
            <p className="welcome-hero-text">{t('HERO_TAGLINE')}</p>
            <div className="welcome-features">
              {features.map((f) => (
                <div key={f.labelKey} className="welcome-feature-item">
                  <div className="welcome-feature-icon">{f.icon}</div>
                  <span className="welcome-feature-label">{t(f.labelKey)}</span>
                </div>
              ))}
            </div>
            <div className="welcome-store-section welcome-store-section--desktop">
              <p className="welcome-store-label">{t('DOWNLOAD_THE_APP')}</p>
              <div className="welcome-store-badges">
                <a
                  href="https://apps.apple.com/app/id1545401235"
                  target="_blank"
                  rel="noreferrer"
                  className="welcome-store-badge welcome-store-badge--apple"
                  id="welcome-appstore-desktop"
                >
                  <img
                    alt="appstore link"
                    src={appstoreImg}
                    className="welcome-store-badge-img"
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.deere.myfinancial"
                  target="_blank"
                  rel="noreferrer"
                  className="welcome-store-badge welcome-store-badge--google"
                  id="welcome-playstore-desktop"
                >
                  <img
                    alt="playstore link"
                    src={playstoreImg}
                    className="welcome-store-badge-img"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile-only: store section + footer */}
      <div className="welcome-mobile-bottom">
        <div className="welcome-store-section">
          <p className="welcome-store-label">{t('DOWNLOAD_THE_APP')}</p>
          <div className="welcome-store-badges">
            <a
              href="https://apps.apple.com/app/id1545401235"
              target="_blank"
              rel="noreferrer"
              className="welcome-store-badge welcome-store-badge--apple"
              id="welcome-appstore-mobile"
            >
              <img
                alt="appstore"
                src={appstoreImg}
                className="welcome-store-badge-img"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.deere.myfinancial"
              target="_blank"
              rel="noreferrer"
              className="welcome-store-badge welcome-store-badge--google"
              id="welcome-playstore-mobile"
            >
              <img
                alt="playstore"
                src={playstoreImg}
                className="welcome-store-badge-img"
              />
            </a>
          </div>
        </div>
        <WelcomeFooter className="welcome-footer" />
      </div>
    </div>
  );
};

export default WelcomePage;
